/* eslint-disable react-hooks/exhaustive-deps */
import * as React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Button,
  Grid,
  CircularProgress,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useTranslation } from "react-i18next";
import i18n from "../../i18";
import dayjs from "dayjs";

import Nursery from "../Images/Nursery.png";
import PrimaryShool from "../Images/PrimaryShool.png";
import SecondarySchool from "../Images/SecondarySchool.png";
import { parseBillIdAsInt } from "./normalizeBillIdDigits";

const GetExpensesReport = () => {
  const { t } = useTranslation();
  const [searchText] = React.useState("");
  const [dataSource, setDataSource] = React.useState([]);
  const [startDate, setStartDate] = React.useState(null);
  const [endDate, setEndDate] = React.useState(null);
  const token = localStorage.getItem("token");
  const [loading, setLoading] = React.useState(true);
  const [selectedImage, setSelectedImage] = React.useState(Nursery);
  const user = JSON.parse(localStorage.getItem("user"));

  React.useEffect(() => {
    const loadUserData = () => {
      const branchId = user?.branch_id || 2;
      const branchImages = {
        1: Nursery,
        2: PrimaryShool,
        3: SecondarySchool,
      };
      setSelectedImage(branchImages[branchId] || Nursery);
    };

    loadUserData();
  }, [user]);
  const branchTitleMap = {
    1: "باخچەی منداڵانی کلیڤەری ناحکومی",
    2: "ناوەندیی کلیڤەری ناحکومی",
    3: "ئامادەی کلیڤەری ناحکومی",
  };
  const branchTitle =
    branchTitleMap[user?.branch_id] || "قوتابخانەی کلیڤەری بنەڕەتی ناحکومی";
  const isRTL = i18n.language === 'ar' || i18n.language === 'ku';
  const printStyles = `
   @media print {
      @page {
        size: auto;
        margin: 5mm;
      }
      body, html {
        width: 100% !important;
        height: auto !important;
        margin: 0 !important;
        padding: 0 !important;
        font-size: 18px !important;
        line-height: 1.5 !important;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
        background-color: white !important;
        direction: ${isRTL ? 'rtl' : 'ltr'} !important;
        text-align: ${isRTL ? 'right' : 'left'} !important;
      }

      body * {
        visibility: hidden;
      }
      .print-content, .print-content * {
        visibility: visible;
        background-color: white !important;
        font-size: 18px !important;
        direction: ${isRTL ? 'rtl' : 'ltr'} !important;
        text-align: ${isRTL ? 'right' : 'left'} !important;
      }
      .print-content {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
          background-color: white !important;

        height: auto;
      }
      .print-header {
        display: block !important;
        text-align: ${isRTL ? 'right' : 'center'};
        margin-bottom: 20px;
        page-break-after: avoid;
        background-color: white !important;
        font-size: 20px !important;
        direction: ${isRTL ? 'rtl' : 'ltr'} !important;
      }
      .no-print {
        display: none !important;
      }
      .table-container {
        width: 100% !important;
        margin: 0 auto !important;
        page-break-inside: auto !important;
        overflow: visible !important;
          background-color: white !important;

      }
      table {
        width: 100% !important;
        border-collapse: separate !important;
        border-spacing: 0 !important;
        page-break-inside: auto !important;
        background-color: white !important;
        font-size: 14px !important;
        border: none !important;
        box-shadow: 0 1px 3px rgba(0,0,0,0.1) !important;
        border-radius: 8px !important;
        overflow: hidden !important;
        direction: ${isRTL ? 'rtl' : 'ltr'} !important;
      }
      tr {
        page-break-inside: avoid !important;
        page-break-after: auto !important;
          background-color: white !important;

      }
      td, th {
        padding: 16px 20px !important;
        border: none !important;
        background-color: white !important;
        font-size: 14px !important;
        text-align: ${isRTL ? 'right' : 'left'} !important;
        vertical-align: middle !important;
        border-bottom: 1px solid #f0f0f0 !important;
        direction: ${isRTL ? 'rtl' : 'ltr'} !important;
      }
      th {
        background: #000080 !important;
        color: #ffffff !important;
        font-weight: 700 !important;
        font-size: 13px !important;
        text-align: ${isRTL ? 'right' : 'center'} !important;
        text-transform: uppercase !important;
        letter-spacing: 0.8px !important;
        border-bottom: 2px solid #dee2e6 !important;
        position: relative !important;
      }
      th, th * {
        background: #000080 !important;
        color: #ffffff !important;
      }
      th, th * {
        font-size: 13px !important;
      }
      th:first-child {
        border-top-left-radius: 8px !important;
      }
      th:last-child {
        border-top-right-radius: 8px !important;
      }
      thead {
        display: table-header-group !important;
        background-color: white !important;
      }
      tbody tr:nth-child(even) {
        background-color: #fafbfc !important;
      }
      tbody tr:nth-child(odd) {
        background-color: white !important;
      }
      tbody tr:hover {
        background-color: #f8f9fa !important;
        transform: translateY(-1px) !important;
        box-shadow: 0 2px 8px rgba(0,0,0,0.08) !important;
      }
      .total-row {
        background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%) !important;
        color: #1565c0 !important;
        font-weight: 700 !important;
        border-top: 3px solid #2196f3 !important;
        border-bottom: none !important;
        position: relative !important;
      }
      .total-row::before {
        content: '' !important;
        position: absolute !important;
        top: 0 !important;
        left: 0 !important;
        right: 0 !important;
        height: 3px !important;
        background: linear-gradient(90deg, #2196f3 0%, #1976d2 100%) !important;
      }
      .total-row td {
        background: transparent !important;
        color: #1565c0 !important;
        font-weight: 700 !important;
        font-size: 16px !important;
        border: none !important;
        border-top: 3px solid #2196f3 !important;
        padding: 20px !important;
        text-align: ${isRTL ? 'right' : 'left'} !important;
        direction: ${isRTL ? 'rtl' : 'ltr'} !important;
      }
      .total-row td:first-child {
        border-bottom-left-radius: 8px !important;
      }
      .total-row td:last-child {
        border-bottom-right-radius: 8px !important;
      }
      @page {
        size: A4;
        margin: 8mm;
      }
      .print-content th {
        font-size: 13px !important;
        background: #000080 !important;
        color: #ffffff !important;
      }
      .print-content th * {
        font-size: 13px !important;
        color: #ffffff !important;
      }
    }
    .print-header {
      display: none;
    }
  `;
  const getCurrentAcademicYear = () => {
    const currentYear = new Date().getFullYear();
    return `${currentYear}-${currentYear + 1}`;
  };
  React.useEffect(() => {
    getApiProducts();
  }, [token]);

  const getApiProducts = async () => {
    try {
      const res = await fetch(
        `https://api.clever-school.com/api/reports/expenses-report`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!res.ok) {
        throw new Error(`HTTP error! Status: ${res.status}`);
      }

      const responseData = await res.json();
      setDataSource(responseData.expenses);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const filteredData = dataSource.filter((row) => {
    const matchesSearchText = Object.values(row).some((val) =>
      String(val).toLowerCase().includes(searchText.toLowerCase())
    );

    const rowDateStr = row.date ? String(row.date).slice(0, 10) : "";
    const startDateStr = startDate
      ? dayjs(startDate).format("YYYY-MM-DD")
      : null;
    const endDateStr = endDate ? dayjs(endDate).format("YYYY-MM-DD") : null;

    const isAfterStartDate = startDateStr
      ? rowDateStr >= startDateStr
      : true;
    const isBeforeEndDate = endDateStr ? rowDateStr <= endDateStr : true;

    return matchesSearchText && isAfterStartDate && isBeforeEndDate;
  });

  const sortedData = [...filteredData].sort((a, b) => {
    const idA = parseBillIdAsInt(a.bill_id);
    const idB = parseBillIdAsInt(b.bill_id);
    const numA = Number.isNaN(idA) ? Number.MAX_SAFE_INTEGER : idA;
    const numB = Number.isNaN(idB) ? Number.MAX_SAFE_INTEGER : idB;
    if (numA !== numB) return numA - numB;
    return (
      new Date(a.date || 0).getTime() - new Date(b.date || 0).getTime()
    );
  });

  const totalFilteredAmount = filteredData.reduce((sum, row) => {
    return sum + parseFloat(row.amount);
  }, 0);

  const columns = [
    {
      title: "#",
      render: (_, __, index) => index + 1,
      width: "60px",
      align: "center",
    },
    { 
      title: t("billId"), 
      dataIndex: "bill_id",
      width: "120px",
      align: "center",
    },
    { 
      title: t("description"), 
      dataIndex: "description",
      width: "auto",
      align: "left",
    },
    {
      title: t("amount"),
      dataIndex: "amount",
      render: (amount) => parseFloat(amount).toLocaleString("en-US"),
      width: "100px",
      align: "right",
    },
    { 
      title: t("date"), 
      dataIndex: "date",
      width: "120px",
      align: "center",
    },
  ];

  const handlePrint = () => {
    window.print();
  };

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress size={60} />
      </Box>
    );
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <style>{printStyles}</style>
      <Box
        className="print-content"
        sx={{ 
          direction: isRTL ? "rtl" : "ltr", 
          textAlign: isRTL ? "right" : "left",
          padding: 2, 
          marginBottom: 17 
        }}
      >
        {/* Print Header */}
        <div className="print-header">
          <div
            style={{
              display: "flex",
              // maxWidth: "600px",
              margin: "0 auto",
              padding: "0",
            }}
          >
            <div
              style={{
                flex: 1,
                textAlign: "right",
                marginRight: "40px",
              }}
            >
              <div
                style={{
                  fontSize: "18px",
                  fontWeight: "bold",
                  marginBottom: "10px",
                }}
              >
                {branchTitle}
              </div>

              <div style={{ fontSize: "16px", marginBottom: "15px" }}>
                ساڵی خوێندن ( {getCurrentAcademicYear()} )
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100px",
                marginLeft: "40px",
              }}
            >
              <img
                src={selectedImage}
                alt="School Logo"
                style={{
                  width: "100%",
                  height: "auto",
                  objectFit: "contain",
                }}
              />
            </div>
          </div>
          <hr
            style={{
              borderColor: "#000",
              margin: "20px 0",
              textAlign: "right",
            }}
          />
          <div
            className="print-title"
            style={{
              color: "red",
              fontSize: "40px",
              fontWeight: "bold",
              "@media print": {
                fontSize: "32px !important",
              },
            }}
          >
            تۆماری خەرجییەکان
          </div>
        </div>

        {/* Controls */}
        <Grid container spacing={2} mb={2} className="no-print">
          <Grid item xs={12} sm={4}>
            <DatePicker
              label={t("startDate")}
              value={startDate}
              onChange={(newValue) => setStartDate(newValue)}
              sx={{
                width: "100%",
                "& .MuiInputLabel-root": {
                  width: "100%",
                  textAlign: "center",
                  "&.Mui-focused": {
                    color: "inherit",
                  },
                },
              }}
              slotProps={{ textField: { size: "small" } }}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <DatePicker
              label={t("endDate")}
              value={endDate}
              onChange={(newValue) => setEndDate(newValue)}
              sx={{
                width: "100%",
                "& .MuiInputLabel-root": {
                  width: "100%",
                  textAlign: "center",
                  "&.Mui-focused": {
                    color: "inherit",
                  },
                },
              }}
              slotProps={{ textField: { size: "small" } }}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <Button
              variant="contained"
              onClick={handlePrint}
              sx={{
                width: "100%",
                height: 40,
                fontWeight: "bold",
                backgroundColor: "#2e7d32",
                "&:hover": { backgroundColor: "#1b5e20" },
              }}
            >
              {t("Print")}
            </Button>
          </Grid>
        </Grid>

        {/* Table */}
        <TableContainer
          component={Paper}
          sx={{
            borderRadius: 2,
            boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
            marginBottom: 20,
            overflow: "hidden",
            border: "1px solid #e9ecef",
            backgroundColor: "white",
            direction: isRTL ? "rtl" : "ltr",
            "@media print": {
              boxShadow: "0 1px 3px rgba(0,0,0,0.1) !important",
              border: "none !important",
              pageBreakInside: "auto",
              direction: isRTL ? "rtl" : "ltr",
              borderRadius: "8px !important",
            },
          }}
          className="table-container"
        >
          <Table sx={{ direction: isRTL ? "rtl" : "ltr" }}>
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.dataIndex || column.title}
                    sx={{
                      background: "#1e3a8a",
                      color: "#ffffff",
                      fontWeight: 700,
                      fontSize: "13px",
                      textAlign: column.align || (isRTL ? 'right' : 'center'),
                      textTransform: "uppercase",
                      letterSpacing: "0.8px",
                      padding: "16px 20px",
                      border: "none",
                      borderBottom: "2px solid #dee2e6",
                      width: column.width || "auto",
                      minWidth: column.width || "auto",
                      maxWidth: column.width || "auto",
                      "@media print": {
                        background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%) !important",
                        color: "#495057 !important",
                        fontSize: "15px !important",
                        border: "none !important",
                        borderBottom: "2px solid #dee2e6 !important",
                        width: column.width || "auto !important",
                        minWidth: column.width || "auto !important",
                        maxWidth: column.width || "auto !important",
                      },
                    }}
                  >
                    {column.title}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {sortedData.map((row, index) => (
                <TableRow
                  key={row.id}
                  sx={{ "&:last-child td": { borderBottom: 0 } }}
                >
                  {columns.map((column) => (
                    <TableCell
                      key={column.dataIndex || column.title}
                      sx={{
                        border: "none",
                        borderBottom: "1px solid #f0f0f0",
                        fontSize: "14px",
                        padding: "16px 20px",
                        textAlign: column.align || (isRTL ? 'right' : 'left'),
                        verticalAlign: "middle",
                        transition: "all 0.2s ease",
                        width: column.width || "auto",
                        minWidth: column.width || "auto",
                        maxWidth: column.width || "auto",
                        "&:hover": {
                          backgroundColor: "#f8f9fa",
                          transform: "translateY(-1px)",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                        },
                        "@media print": {
                          padding: "16px 20px !important",
                          border: "none !important",
                          borderBottom: "1px solid #f0f0f0 !important",
                          fontSize: "14px !important",
                          width: column.width || "auto !important",
                          minWidth: column.width || "auto !important",
                          maxWidth: column.width || "auto !important",
                        },
                      }}
                    >
                      {column.render
                        ? column.render(row[column.dataIndex], row, index)
                        : row[column.dataIndex]}
                    </TableCell>
                  ))}
                </TableRow>
              ))}

              {/* Total Row */}
              <TableRow
                className="total-row"
                sx={{
                  backgroundColor: "#e3f2fd",
                  "@media print": {
                    backgroundColor: "#e3f2fd !important",
                  },
                }}
              >
                <TableCell
                  colSpan={3}
                  align="right"
                  sx={{ 
                    background: "linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)",
                    color: "#1565c0",
                    fontWeight: 700,
                    fontSize: "16px",
                    padding: "20px",
                    border: "none",
                    borderTop: "3px solid #2196f3",
                    position: "relative",
                    "@media print": {
                      background: "linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%) !important",
                      color: "#1565c0 !important",
                      border: "none !important",
                      borderTop: "3px solid #2196f3 !important",
                      fontSize: "16px !important",
                    },
                  }}
                >
                  {t("total")}
                </TableCell>
                <TableCell sx={{ 
                  background: "linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)",
                  color: "#1565c0",
                  fontWeight: 700,
                  fontSize: "16px",
                  padding: "20px",
                  border: "none",
                  borderTop: "3px solid #2196f3",
                  "@media print": {
                    background: "linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%) !important",
                    color: "#1565c0 !important",
                    border: "none !important",
                    borderTop: "3px solid #2196f3 !important",
                    fontSize: "16px !important",
                  },
                }}>
                  {totalFilteredAmount.toLocaleString("en-US")}
                </TableCell>
                <TableCell sx={{
                  background: "linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)",
                  color: "#1565c0",
                  border: "none",
                  borderTop: "3px solid #2196f3",
                  "@media print": {
                    background: "linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%) !important",
                    color: "#1565c0 !important",
                    border: "none !important",
                    borderTop: "3px solid #2196f3 !important",
                  },
                }}></TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </LocalizationProvider>
  );
};

export default GetExpensesReport;
